import brandExperienceUrl from "../assets/blackrednow-multiplatform.jpg";

interface Props {
  compact?: boolean;
  className?: string;
}

/** Hero de marca compartido por web, Electron y Android. El movimiento sigue al puntero
 * sin estado React y queda desactivado automáticamente cuando el sistema reduce animaciones. */
export function BrandExperience({ compact = false, className }: Props) {
  function move(event: React.PointerEvent<HTMLDivElement>) {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
    event.currentTarget.style.setProperty("--brand-rotate-x", `${(-y * 3.5).toFixed(2)}deg`);
    event.currentTarget.style.setProperty("--brand-rotate-y", `${(x * 5).toFixed(2)}deg`);
    event.currentTarget.style.setProperty("--brand-light-x", `${((x + 1) * 50).toFixed(1)}%`);
    event.currentTarget.style.setProperty("--brand-light-y", `${((y + 1) * 50).toFixed(1)}%`);
  }

  function reset(event: React.PointerEvent<HTMLDivElement>) {
    event.currentTarget.style.removeProperty("--brand-rotate-x");
    event.currentTarget.style.removeProperty("--brand-rotate-y");
    event.currentTarget.style.removeProperty("--brand-light-x");
    event.currentTarget.style.removeProperty("--brand-light-y");
  }

  return (
    <div
      className={["brand-experience", compact && "is-compact", className].filter(Boolean).join(" ")}
      onPointerMove={move}
      onPointerLeave={reset}
    >
      <div className="brand-experience-halo" aria-hidden="true" />
      <div className="brand-experience-card">
        <img
          src={brandExperienceUrl}
          alt="BlackRedNow Modern Multiplatform"
          draggable="false"
          fetchPriority="high"
        />
        <span className="brand-experience-scan" aria-hidden="true" />
        <span className="brand-experience-glint" aria-hidden="true" />
      </div>
      <span className="brand-spark spark-a" aria-hidden="true" />
      <span className="brand-spark spark-b" aria-hidden="true" />
      <span className="brand-spark spark-c" aria-hidden="true" />
    </div>
  );
}
